import { Component, Inject } from "@angular/core";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { PatientService } from "../../../services/patient.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AutogestionService } from "src/app/services/autogestion/autogestion.service";

@Component({
  selector: "patient-change-autogestion-pass-dialog",
  templateUrl: "patient-change-autogestion-pass.component.html",
  styleUrls: ["./patient-change-autogestion-pass.component.css"],
})
export class PatientChangeAutogestionPassDialogComponent {
  patientId: number;
  firstName: string;
  lastName: string;
  document: string;
  form: FormGroup;
  loading: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private autogestionService: AutogestionService,
    private notificationToastService: NotificationToastService,
    public dialogRef: MatDialogRef<PatientChangeAutogestionPassDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.patientId = this.data.patientId;
    this.firstName = this.data.firstName;
    this.lastName = this.data.lastName;
    this.document = this.data.document;

    this.form = this.formBuilder.group(
      {
        password: [ `${this.document}${ this.firstName.replace(/\s/g, "").toUpperCase() }`, Validators.required],
      },
    );
  }

  async changePass() {
    try {

      if (this.form.valid) {
        this.loading = true;
        await this.autogestionService.resetPassword(
          this.patientId,
          this.form.value.password
        );

        this.dialogRef.close();
      }
    } catch (err) {
      this.notificationToastService.error(
        err.error,
        "Cambio de contraseña"
      );
    } finally {
      this.loading = false;
    }
  }

  async close() {
    this.dialogRef.close();
  }
}
